<!-- 購入内容確認の上部表示 購入内容テーブル -->
<template>
  <div v-if="isReadyToDraw">
    <!-- チケット名 -->
    <MbNameDisp :name="masterBook.name" />

    <!--発駅 箱根フリーパス・丹沢/大山のみ表示  -->
    <BFromStationSelect
      v-if="book.price.from_station"
      :name="book.price.from_station.name"
    />

    <!-- サブスク以外表示 1日のみの場合はスタート日のみ 1日以上はスタート日&終了日 -->
    <div v-if="!isSubscription">
      <BAvailablePeriod
        v-if="book.user_started_at"
        :period="masterBook.valid_period"
        :start="book.user_started_at"
        :limit="limitedAtMinusStartHour"
      />
      <!-- book.user_started_atがない場合、book.available_started_atを使用 -->
      <!-- availableを使う場合は、valid_period:1daysでも終了日時を表示するので、isBeforeValid=trueで制御　-->
      <BAvailablePeriod
        v-else
        :period="masterBook.valid_period"
        :start="book.available_started_at"
        :limit="limitedAtMinusStartHour"
        :isBeforeValid="true"
      />
    </div>

    <!-- 購入枚数 -->
    <BgDivisionCount :label="bookGroup.divisions_label" />

    <!-- 決済方法 -->
    <PaymentMethod :label="inputPaymentMethod.name"/>

    <hr />

    <!-- お支払い総額 -->
    <BgPaymentAmount :totalPrice="divisionCalTotalPrice" />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import moment from "@/services/moment";
import commonService from "@/services/common";
import myTicketsCommonService from "@/services/common/myTickets";
import bookGroupService from "@/services/bookGroup";

export default {
  name: "TheBBCUpper",
  setup() {
    const store = useStore();

    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);

    const inputPaymentMethod = computed(() => store.getters["input/ticketing/storePaymentMethod"]);

    const divisionCalTotalPrice = computed(() =>
      bookGroupService.calTotal(bookGroup.value)
    );
    const isSubscription = computed(() =>
      commonService.checkIsSubscription(masterBook.value.id)
    );
    const isReadyToDraw = ref(false);
    const limitedAtMinusStartHour = computed(() => {
      // book.user_XXX_atがある場合
      if (book.value.user_started_at) {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.user_limited_at,
          masterBook.value.start_hour
        );
        // book.user_XXX_atがない場合
      } else {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.available_limited_at,
          masterBook.value.start_hour
        );
      }
    });

    watchEffect(() => {
      if (divisionCalTotalPrice.value > 0) {
        isReadyToDraw.value = true;
      }
    });

    return {
      masterBook,
      book,
      bookGroup,
      divisionCalTotalPrice,
      isReadyToDraw,
      isSubscription,
      limitedAtMinusStartHour,
      inputPaymentMethod
    };
  },
};
</script>
